import { createAction, props } from '@ngrx/store';
import { NewsItem, NewsReactionInput, NewsTypesItem } from '@cpd-app/generated';

export const getNews = createAction('[News] get news');

export const getNewsSuccess = createAction(
  '[News] get news success',
  props<{ news: NewsItem[] }>()
);

export const getNewsTypesSuccess = createAction(
  '[News] get news types success',
  props<{ newsTypes: NewsTypesItem[] }>()
);

export const getNewsTypesFailure = createAction(
  '[News] get news types failure',
  props<{ error: any }>()
);

export const reactOnNews = createAction(
  '[News] react on news',
  props<{ input: NewsReactionInput }>()
);

export const reactOnNewsSuccess = createAction(
  '[News] react on news success',
  props<{ newsItem: NewsItem }>()
);

export const reactOnNewsFailure = createAction(
  '[News] react on news failure',
  props<{ error: any }>()
);
